module.exports = __webpack_public_path__ + "static/media/logo.78e4fd98.svg";